module.exports = __webpack_public_path__ + "bcd1970b26ebc2c2a642b1aaa5c19bb5.png";